document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".beschreibung_rich-text").forEach((text) => {
    let content = text.innerHTML;
    
    content = content.replace(
      /\[col\](.*?)\[\/col\]/gs,
      '<div class="col-container">$1</div>'
    );

    text.innerHTML = content;

    text.querySelectorAll('.col-container *:not(li)').forEach(element => {
      element.classList.add('two-columns');
    });
  });
});